import React from "react";
import { SectionPoster } from "../shared/PosterTemplate";

const Health = ({parentPath}) =>
  <SectionPoster sectionName='health' backRoute={parentPath} />

export default Health;